/* eslint-disable jsx-a11y/iframe-has-title */
import { parseVideo } from "~/shared/util/getYouTubeID";

interface VideoEmbedProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  url: string | null;
}

const VideoEmbed = ({ url, ...rest }: VideoEmbedProps) => {
  if (!url || typeof url !== "string") return null;

  const videoInfo = parseVideo(url);

  if (!videoInfo?.id || !videoInfo?.type) return null;

  if (videoInfo.type === "youtube") {
    return <iframe width="160" height="90" {...rest} src={`https://www.youtube.com/embed/${videoInfo.id}?rel=0`} />;
  }

  if (videoInfo.type === "vimeo") {
    return <iframe width="160" height="90" {...rest} src={`https://player.vimeo.com/video/${videoInfo.id}`} />;
  }

  return null;
};

export default VideoEmbed;
